import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface ProductPageLayoutProps {
  children: React.ReactNode;
}

export default function ProductPageLayout({ children }: ProductPageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}